// extracted by mini-css-extract-plugin
export var deliveryRow = "_pe-a";
export var fixedHeight = "_pe-4";
export var freightLogo = "_pe-9";
export var fullWidth = "_pe-3";
export var priceColumn = "_pe-5";
export var radioSelected = "_pe-7";
export var radioUnselected = "_pe-6";
export var selectedOption = "_pe-2";
export var selectedOptionContainer = "_pe-1";
export var selection = "_pe-0";
export var tallSkeletonText = "_pe-8";